import type { UniqueIdentifier } from "@dnd-kit/core";
import type { UseMutationOptions } from "@tanstack/react-query";
import type { SVGProps } from "react";
import type * as icons from "~/assets/svgs";

export type IconName = keyof typeof icons;
export type SVGComponentProps = SVGProps<SVGSVGElement>;

export type CourseListLayout = "table" | "card";

export type AtLeastOne<T> = {
  [K in keyof T]-?: Pick<T, K> & Partial<Omit<T, K>>;
}[keyof T];

export type ToMediaQueryObjectParam = AtLeastOne<{
  minWidth?: number;
  maxWidth?: number;
}>;

export type ApiErrorResponse = {
  statusCode: number;
  message: string | string[];
  error?: string;
  errorCode?: string;
};

export type MutationOptions<TData, TError, TVariables> = Omit<
  UseMutationOptions<TData, TError, TVariables>,
  "mutationFn"
>;

export type EmptyObject = Record<PropertyKey, never>;

export type ToSortable<T> = T & {
  sortableId: UniqueIdentifier;
};

export const CURRENT_USER_STORAGE_KEY = "current-user-storage";
